import http from "./http";

export default {
  users() {
    return http().get('/v1/smrtphone');
  },
  create(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/smrtphone`, data);
  },
  delete(smrtPhoneId) {
    return http().delete(`/v1/smrtphone/${smrtPhoneId}`);
  },
  linkSmrtPhoneUsers(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/smrtphone/link_users`, data);
  },
  syncSmrtPhoneUsers() {
    return http().post(`/v1/smrtphone/sync/users`);
  },
  syncSmrtPhoneNumbers() {
    return http().post(`/v1/smrtphone/sync/numbers`);
  },
  updateSmrtPhoneAPIKey(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/smrtphone/api_token`, data);
  },
}
